import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCollapse = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.575 12.2002L13.435 13.1011C12.9537 13.5605 12.1963 13.5605 11.715 13.1011L12.575 12.2002ZM22.7463 0.76939C23.2439 0.294437 24.0323 0.312772 24.5072 0.810342C24.9822 1.30791 24.9639 2.0963 24.4663 2.57125L22.7463 0.76939ZM0.683723 2.57125C0.186153 2.0963 0.167819 1.30791 0.642772 0.810342C1.11772 0.312772 1.90611 0.294437 2.40368 0.76939L0.683723 2.57125ZM11.715 11.2993L22.7463 0.76939L24.4663 2.57125L13.435 13.1011L11.715 11.2993ZM2.40368 0.76939L13.435 11.2993L11.715 13.1011L0.683723 2.57125L2.40368 0.76939Z",
		fill: "#222222"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.575 22.73L13.435 23.6309C12.9537 24.0903 12.1963 24.0903 11.715 23.6309L12.575 22.73ZM22.7463 11.2992C23.2439 10.8242 24.0323 10.8426 24.5072 11.3401C24.9822 11.8377 24.9639 12.6261 24.4663 13.101L22.7463 11.2992ZM0.683723 13.101C0.186153 12.6261 0.167819 11.8377 0.642772 11.3401C1.11772 10.8426 1.90611 10.8242 2.40368 11.2992L0.683723 13.101ZM11.715 21.8291L22.7463 11.2992L24.4663 13.101L13.435 23.6309L11.715 21.8291ZM2.40368 11.2992L13.435 21.8291L11.715 23.6309L0.683723 13.101L2.40368 11.2992Z",
		fill: "#222222"
	})]
});
export default SvgCollapse;
